import { Grid } from '@material-ui/core'
import React, {useState, useEffect} from 'react'
import LineInputText from '../../../../../components/Inputs/LineInputText/LineInputText'
import ModalBase from '../../../../../components/Modals/ModalBase'
import DisplayText from '../../../../../components/Texts/DisplayText'
import { onValidateForm } from '../../../../../shared/utility'
import {formData } from './data'
import SubmitModalButton from '../../../../../components/Buttons/SubmitModalButton'
import {request_edit_approval_contact, request_check_username} from '../../requests'

const EditEmailModal = props => {

    const {initData, patientID, open, onClose, onRequetsContacts} = props
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [valid, setValid] = useState(false)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if(!initData) return
        let temp = {...form}
        Object.keys(form).forEach( item =>{
            let newValue = initData[item] 
            if(newValue !== null && newValue !== undefined){
                temp[item].value = newValue
                temp[item].isValid = true
                temp[item].isVisited = true
            }
        })
        setValid(onValidateForm(temp))
        setForm(temp)
        setError(null)
        setLoading(false)
    }, [initData, open])


    const onInputChange = (data) => {
        const id = data.config.id;
        let temp = {...form};
        temp[id] = {...data};
        setValid(onValidateForm(temp))
        setForm(temp)
        setError(null)
    }

    const onSubmit = async() => {
        if(!valid){
            setError('Llena los campos faltantes')
            return
        }
        
        let data2send = {}
        Object.keys(form).forEach(item => {
            if((initData[item] !== form[item].value) && form[item].isValid){
                data2send = {...data2send, [item]: form[item].value}
            }
        })
        console.log(data2send)
        const {id_approval_contact} = initData
        setLoading(true)
        try {
            await request_edit_approval_contact(id_approval_contact, data2send)
            onRequetsContacts()
            //setLoading(false)
            //onClose()
        } catch (error) {
            console.log(error)
            setError('Hubo un error')
        }
        setLoading(false)


    }
    

    return(
        <ModalBase open={open} onClose={onClose} maxWidth='sm'>
            <div>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <DisplayText variant='h6'>Nuevo correo de aprobación</DisplayText>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={12}>
                                <LineInputText 
                                data={form.name}
                                onChange={onInputChange}/>
                            </Grid> 
                            <Grid item xs={12} md={12}>
                                <LineInputText 
                                data={form.email}
                                onChange={onInputChange}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <SubmitModalButton label='Agregar' error={error} loading={loading} onSubmit={onSubmit}/>
                    </Grid>
                </Grid>
            </div>
        </ModalBase>
    )
}

export default EditEmailModal